const apiUrl = import.meta.env.VITE_APP_BACKEND_API_URL as string;

const baseUrl = `${apiUrl}/organizations/current`;

export const bffEndpoints = {
  invalidateToken: "/v1/auth/token"
};

export const userEndpoints = {
  // Notes
  // GET /users/{userGUIDId} works OK w Frontdoor
  // GET /users/{email} does NOT work w Frontdoor
  // GET /users?email=abc@example.com works OK w Frontdoor
  getUserBy: () => `${apiUrl}/users`,

  getUserByCurrentOrganization: (userId: string) => `${baseUrl}/users/${userId}`
};

export const organizationEndpoints = {
  organizationName: () => `${baseUrl}/name`,
  organizationById: (organizationId: string) =>
    `${apiUrl}/organizations/${organizationId}`,
  organizationDetails: () => baseUrl,
  updateOrganizationName: () => `${baseUrl}/name`
};

export const apiUsersEndpoints = {
  usersList: () => `${baseUrl}/api-users`,
  getApiUserById: (apiUserId: string) => `/api-users/${apiUserId}`,
  createApiUser: () => `/api-users`, // for POST
  updateApiUser: () => `/api-users`, // for PUT or PATCH
  deleteApiUser: (apiUserId: string) =>
    `${baseUrl}/api-user/${apiUserId}/delete`,

  secretsList: () => `${baseUrl}/api-secrets`,
  createApiSecret: () => `${baseUrl}/api-secrets`, // for POST
  deleteApiSecret: () => `${baseUrl}/api-secrets`, // for DELETE

  applicationsList: () => `${baseUrl}/applications`, // TBD

  appRolesList: () => `${baseUrl}/app-roles`,
  addAppRoles: () => `${baseUrl}/app-roles`, // for POST
  updateAppRoles: () => `${baseUrl}/app-roles` // for PUT or PATCH
};

export const organizationUserEndpoints = {
  organizationUsers: () => `${baseUrl}/users`,
  addUser: () => `${baseUrl}/users`,
  updateUserRole: (userId: string) => `${baseUrl}/users/${userId}`,
  removeUser: (userId: string) => `${baseUrl}/users/${userId}`
};

export const applicationEndpoints = {
  getCurrentOrganizationApplications: () => `${baseUrl}/applications`,
  applicationUsers: (applicationId: string) =>
    `${baseUrl}/applications/${applicationId}/users`,
  applicationRoles: (applicationId: string) =>
    `${baseUrl}/applications/${applicationId}/roles`,
  userApplications: (userId: string) =>
    `${baseUrl}/users/${userId}/applications`,
  updateOrDeleteApplicationUsers: (
    applicationId: string,
    userId: string
  ): string => `${baseUrl}/applications/${applicationId}/users/${userId}`
};
